// Libs
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// Component
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { isEmpty } from 'lodash';
import { isGroupHasChildren } from '../../groups/helper';
import { isClosedFloorField, isClosedPositionField } from '../../core/helper';

const TicketToggleGroups = props => {
    const [group, setGroup] = useState(props.selected);
    const required = props.required;
    const [options, setOptions] = useState(props.options);
    const groupsList = useSelector(state => state.groups.list);
    const workspaceSettings = useSelector(state => state.workspace.settings);
    const floorMode = workspaceSettings.mode_floor ? workspaceSettings.mode_floor : 'close';
    const positionMode = workspaceSettings.mode_position ? workspaceSettings.mode_position : 'close';

    const changeGroup = (event, newGroup) => {
        if (!required) {
            setGroup(newGroup);
            props.onChange(newGroup);
        } else if (required && newGroup !== null) {
            setGroup(newGroup);
            props.onChange(newGroup);
        }
    };

    useEffect(() => { // Reset the group when the selected group changes
        setGroup(props.selected);
    }, [props.selected]);

    useEffect(() => { // Reset the options when the options change
        if (!isEmpty(props.options) && (
            props.groupType === 'BATIMENT' && isClosedFloorField(workspaceSettings.name, floorMode)
            || props.groupType === 'FLOOR' && isClosedPositionField(workspaceSettings.name, positionMode)
        )) {
            setOptions(props.options.filter(g => isGroupHasChildren(groupsList, g.id)));
        } else {
            setOptions(props.options);
        }
    }, [props.options]);


    return (
        <div className={'select-wrapper'} style={{ marginTop: 20, marginBottom: 20 }}>
            <ToggleButtonGroup
                exclusive
                value={group}
                onChange={changeGroup}
                classes={{
                    root: 'toggle_button_group'
                }}
            >
                {
                    options && options.map(option => (
                        <ToggleButton
                            classes={{
                                root: 'toggle_button',
                                selected: 'toggle_button-selected selected_group',
                                label: 'toggle_button_label'
                            }}
                            key={option?.id}
                            value={option?.id}
                        >
                            {option.value}
                        </ToggleButton>
                    ))
                }
            </ToggleButtonGroup>
        </div>
    );
};

export default TicketToggleGroups;
